import React from 'react';
import {CommonEdit} from '../Common';
import {getInputs} from './Common';
import {useNotify, SaveButton, DeleteButton, Toolbar} from 'react-admin';

const SafeToolbar = props => {
  const notify = useNotify();

  const handleFailure = error => {
    if (error.message === 'FOREIGN_KEY_CONSTRAINT_VIOLATION' || error.status === 409) {
      notify(
        'Il existe au moins un document avec ce type, la suppression est impossible',
        {type: 'warning'}
      );
    } else {
      notify('Une erreur est survenue', {type: 'warning'});
    }
  };

  return (
    <Toolbar {...props} style={{justifyContent: 'space-between'}}>
      <SaveButton />
      <DeleteButton mutationMode="pessimistic" onFailure={handleFailure} />
    </Toolbar>
  );
};

export const DocumentTypeEdit = props => {
  return (
    <CommonEdit
      {...{
        ...props,
        fields: getInputs(),
        children: {
          toolbar: <SafeToolbar />,
        },
      }}
    />
  );
};
